import { logout } from "../utils/authUtils";
import { ErrorToast } from "../widgets/AppToast";
import { ApiURL } from "./apiConstants";
import instance from "./axiosInterceptors";

export const post = async (url, formData) => {
  const login_token = localStorage.getItem("login_token");
  const refresh_token = localStorage.getItem("refresh_token");
  formData.append("login_token", login_token);
  formData.append("refresh_token", refresh_token);
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return instance
    .post(url, formData, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized, please login again.");
        const errorMessage = "Unauthorized access. Please Login again.";
        ErrorToast("Login Error ", errorMessage);
        setTimeout(() => {
          logout();
        }, 5000);
      }
      return error;
    });
};

export const get = async (url) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .get(url, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const downloadRestHoursPDF = async (payload) => {
  const login_token = localStorage.getItem("login_token");
  const refresh_token = localStorage.getItem("refresh_token");

  const formData = new FormData();
  if (payload.ship_id) {
    formData.append("ship_id", payload.ship_id);
  }
  formData.append("month", payload.month);
  formData.append("year", payload.year);

  payload.staff_ids.forEach((id) => {
    formData.append("staff_ids", id);
  });

  formData.append("login_token", login_token);
  formData.append("refresh_token", refresh_token);

  const response = await instance.post(
    ApiURL.download_rest_hours_pdf_com,
    formData,
    {
      responseType: "blob",
    },
  );

  const disposition = response.headers["content-disposition"] || "";
  const filenameMatch = disposition.match(
    /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i,
  );

  return {
    blob: response.data,
    filename: filenameMatch ? decodeURIComponent(filenameMatch[1]) : null,
  };
};

export const downloadStaffRestHoursPDF = async (payload) => {
  const login_token = localStorage.getItem("login_token");
  const refresh_token = localStorage.getItem("refresh_token");

  const formData = new FormData();

  formData.append("month", payload.month);
  formData.append("year", payload.year);

  payload.staff_ids.forEach((id) => {
    formData.append("staff_ids", id);
  });

  formData.append("login_token", login_token);
  formData.append("refresh_token", refresh_token);

  const response = await instance.post(
    ApiURL.download_rest_hours_pdf_staff,
    formData,
    {
      responseType: "blob",
    },
  );

  const disposition = response.headers["content-disposition"] || "";
  const filenameMatch = disposition.match(
    /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i,
  );

  return {
    blob: response.data,
    filename: filenameMatch ? decodeURIComponent(filenameMatch[1]) : null,
  };
};

export const put = async (url, formData, type) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .put(url, formData, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const deleteApi = async (url) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .delete(url, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const ImageUpload = async (url, data) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .post(url, data, options)
    .then(function (response) {
      if (response?.data?.success == 0) {
      }
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const sendLogToServer = async (data) => {
  try {
    const res = await fetch("/api/engine-log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await res.json();
  } catch (err) {
    console.error("Error syncing log to server:", err);
  }
};
